import { Box as BoxFigure } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import type { SxProps } from '../../themes/themes';
import { FinalContainer } from '../FinalGrid/FinalGrid';
import { DEFAULT_MARGIN_TEXT } from '../Spacer/Spacer';
import { Typography } from '../Typography/Typography';
import { getStyles } from './Image.styles';

export interface ImageProps {
  caption?: string;
  extendedCaption?: string;
  alignment?: 'left' | 'center' | 'right';
}

// TODO: text: 5 should not be used, this is just a maxWidth helper, but due of non folding paddings, i am lost about a better solution

// TODO: markdown beschreibung informtative, dekorativ etc pp

export const Image: React.FC<PropsWithChildren<ImageProps>> = ({
  children,
  caption,
  extendedCaption,
  alignment,
  ...props
}) => {
  const styles = getStyles();

  return (
    <BoxFigure component="figure" sx={{ ...styles.figure, ...styles.figureAlignment[alignment] } as SxProps} {...props}>
      {children}
      {caption || extendedCaption ? (
        <FinalContainer
          maxWidth="text"
          component="figcaption"
          marginTop={DEFAULT_MARGIN_TEXT}
          marginBottom={0}
          rowGap={{ xs: 2, lg: 3 }}
        >
          {caption && (
            <Typography variant="body2" fontWeight="bold" innerPadding="horizontal">
              {caption}
            </Typography>
          )}
          {extendedCaption && (
            <Typography variant="body2" innerPadding="horizontal">
              {extendedCaption}
            </Typography>
          )}
        </FinalContainer>
      ) : null}
    </BoxFigure>
  );
};
